<script setup>
import dashboardService from "@/services/ecosystem/dashboard.service";
import {ref, onMounted, computed} from "vue";
import NeedsActivities from "@/views/ecosystem/home/NeedsActivities.vue";
import NeedsAlerts from "@/views/ecosystem/home/NeedsAlerts.vue";

const numbers = ref(null);
const likedPerc = computed(() => parseInt(numbers.value.liked / numbers.value.startups * 100));
const advancedPerc = computed(() => parseInt(numbers.value.advanced / numbers.value.startups * 100));

onMounted(() => {
    getNumbers();
});

async function getNumbers() {
    const {data} = await dashboardService.getNeedsSolutionsNumbers();
    numbers.value = data;
}
</script>

<template>
    <aside class="dashboard-page__sidebar dashboard-page__sidebar--bordered">
        <h3 class="dashboard-page__title">Your network</h3>

        <div v-if="false" class="dashboard-page__gradient">
            <h3 class="dashboard-page__title">Contributor status</h3>
            <b class="dashboard-page__contributor">Top 10%</b>

            <p>Your recommendations are being reviewed and advanced by enterprise teams.</p>
        </div>

        <div v-if="numbers?.startups" class="dashboard-page__plate">
            <header class="dashboard-page__plate__header">
                <h6 class="heading6 heading6--ecosystem">Your Contributions</h6>
            </header>

            <div class="dashboard-page__plate__content">
                <ul class="dashboard-page__stat">
                    <li>
                        <big>{{ numbers.startups }}</big>
                        <p>solutions sent to {{ numbers.needs }}
                            <template v-if="numbers.needs > 1">
                                <br/> different needs
                            </template>
                            <template v-else>
                                need
                            </template>
                        </p>
                    </li>
                </ul>

                <ul class="dashboard-page__seats-list">
                    <li>
                        <span class="dashboard-page__seats-list__title">Matched to need by user</span>

                        <div class="dashboard-page__seats-list__inner">
                            <div class="progress">
                                <div class="progress-bar" role="progressbar" :style="{'width': `${likedPerc}%`}" aria-valuemin="0"
                                     aria-valuemax="100"></div>
                            </div>
                            <span>{{ likedPerc }}%</span>
                        </div>
                    </li>
                    <li>
                        <span class="dashboard-page__seats-list__title">Advanced to project</span>

                        <div class="dashboard-page__seats-list__inner">
                            <div class="progress">
                                <div class="progress-bar" role="progressbar" :style="{'width': `${advancedPerc}%`}" aria-valuemin="0"
                                     aria-valuemax="100"></div>
                            </div>
                            <span>{{ advancedPerc }}%</span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <NeedsAlerts/>

        <NeedsActivities/>
    </aside>
</template>

<style scoped>

</style>
